// import React from "react";
// import { CardContent, Box, Typography, Button } from "@mui/material";
// import WhatsAppIcon from "src/assets/images/settings/whatsapp_logo.png";
// import NotConnectedBox from "./notConnectedBox";
// import ConnectedBox from "./connected";
// import ErrorBox from "./errorBox";
// import useStyle from "./Styles";
import React from "react";
import { CardContent, Box, IconButton, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
import { useSelector } from "react-redux";
import UPDATE_USER_GUIDE from "src/graphql/mutation/user_guide/updateUserGuide";
import GET_USER_GUIDE from "src/graphql/query/user_guide/getUserGuide";
import { HelpOutline } from "@mui/icons-material";
import { useTour } from "src/context/global/TourContext";
import WhatsappInstructionsModal from "./whatsappInstructionsModal";
import NotConnectedBox from "./notConnectedBox";
import ConnectedBox from "./connected";
import ErrorBox from "./errorBox";
import useStyle from "./Styles";

interface IExternalPage {
  handleClick: any;
  facebookUserProfile: any;
  waProcessLoading: boolean;
  logout: any;
  //
  pageExistingError: any;
  handleClickError: any;
  setErrorBoxHeight: any;
  modalRef: any;
  isCollapsed: boolean;
}

const ExternalPage: React.FC<IExternalPage> = ({
  modalRef,
  handleClick,
  facebookUserProfile,
  waProcessLoading,
  logout,
  //
  pageExistingError,
  handleClickError,
  setErrorBoxHeight,
  isCollapsed,
}) => {
  const { classes } = useStyle();
  const { me }: any = useSelector((state: any) => state.me);
  const { guideData, guideLoading } = useTour();
  const [updateUserGuide] = useMutation(UPDATE_USER_GUIDE);

  const hasAutoOpened = React.useRef(false);

  // Auto-open instructions modal on first visit
  React.useEffect(() => {
    if (
      !guideLoading &&
      guideData?.getUserGuide?.whatsappGuideCompleted === false &&
      !hasAutoOpened.current &&
      modalRef.current
    ) {
      hasAutoOpened.current = true;
      modalRef.current.handleOpen();
    }
  }, [guideLoading, guideData]);

  return (
    <CardContent className={classes.cardContent}>
      <Box>
        {!facebookUserProfile ? (
          <Box sx={{ position: "relative", width: "100%" }}>
            <Box sx={{ position: "absolute", right: 0, top: 0 }}>
              <Tooltip title="Connection Instructions">
                <IconButton
                  size="small"
                  onClick={() => modalRef.current?.handleOpen()}
                  sx={{
                    color: "#4D1277",
                    opacity: 0.7,
                    "&:hover": { opacity: 1 },
                  }}
                >
                  <HelpOutline fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
            <NotConnectedBox
              handleClick={handleClick}
              handleOpenInstructions={() => modalRef.current?.handleOpen()}
              isCollapsed={isCollapsed}
            />
          </Box>
        ) : (
          <Box sx={{ position: "relative", width: "100%" }}>
            <Box sx={{ position: "absolute", right: 0, top: 0 }}>
              <Tooltip title="Connection Instructions">
                <IconButton
                  size="small"
                  onClick={() => modalRef.current?.handleOpen()}
                  sx={{
                    color: "#4D1277",
                    opacity: 0.7,
                    "&:hover": { opacity: 1 },
                  }}
                >
                  <HelpOutline fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
            <ConnectedBox
              user={facebookUserProfile}
              logout={logout}
              handleAddMorePages={handleClick}
              loading={waProcessLoading}
              isCollapsed={isCollapsed}
            />
          </Box>
        )}
        <WhatsappInstructionsModal
          ref={modalRef}
          setModalState={async (open) => {
            if (
              !open &&
              me?.id &&
              guideData?.getUserGuide?.whatsappGuideCompleted === false
            ) {
              try {
                await updateUserGuide({
                  variables: {
                    agentId: me.id,
                    whatsappGuideCompleted: true,
                  },
                  refetchQueries: [
                    { query: GET_USER_GUIDE, variables: { agentId: me.id } },
                  ],
                });
              } catch (error) {
                console.error("Failed to update whatsapp guide status", error);
              }
            }
          }}
        />
      </Box>
      <ErrorBox
        error={pageExistingError || ""}
        handleClick={handleClickError}
        setErrorHeight={setErrorBoxHeight}
      />
    </CardContent>
  );
};

export default ExternalPage;
